import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/variables.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { HitlNotificationProvider } from './context/HitlNotificationContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HitlNotificationProvider>
      <App />
    </HitlNotificationProvider>
  </React.StrictMode>
);

reportWebVitals();
